<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home/Home' }">Home</el-breadcrumb-item>
      <el-breadcrumb-item>Real Time</el-breadcrumb-item>
    </el-breadcrumb>
    <p></p>
    <el-container>
      <el-card class="box-card col-lg-4">
        <div slot="header" class="clearfix">
          <span>Machine Interface</span>
          <el-button style="float: right;" size="mini" type="success" @click="modifyParameters">Parameters Setting</el-button>
        </div>
        <div class="text item">
          <div id="realTime-bg">
            <img :src="imgsrc" width="100%" />
            <p v-show="showFluence" :class="fluenceClass">{{fluence.num}}</p>
            <p v-show="showPulse" :class="pulseClass">{{pulse.num}}</p>
            <p v-show="showFrequency" :class="frequencyClass">{{frequency.num}}</p>
            <p v-show="showCooling" :class="coolingClass">{{cooling.num}}</p>
          </div>
        </div>
      </el-card>
      <el-card class="box-card col-lg-5">
        <div slot="header" class="clearfix">
          <span>Chat Box</span>
        </div>
        <div class="text item">
          <div id="content-wrap">
            <div class="infinite-list" v-infinite-scroll="load" :infinite-scroll-disabled="scrollDisabled" style="overflow:auto">
              <div>
              <p v-if="loading">loading...</p>
                <div :class="v.sender === user?'myself':'user'" v-for="v in chatData">
                  <p style="min-height: 60px;">
                    <span class="name">{{ v.nickName }}</span>
                    <span class="content">{{ v.content }}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div>
            <el-form :inline="true" :model="chatForminline" class="user-search">
              <el-input style="width: 76%;" v-model="chatForminline.content" placeholder="请输入内容" size="small"></el-input>
              <el-button style="width: 20%;" :plain="true" type="primary" size="small" @click="sendMsg" :loading="loading">Send</el-button>
            </el-form>
          </div>
        </div>
      </el-card>
      <el-card class="box-card col-lg-6">
        <div slot="header" class="clearfix">
          <span>Machine Information</span>
        </div>
        <div class="text item">
          <div class="wrap-li">
            <span class="title">Machine S/N:</span>
            <span class="message">{{ machineList.softwareSerialNumber }}</span>
            <el-divider></el-divider>
          </div>
          <div class="wrap-li">
            <span class="title">Name:</span>
            <span class="message">{{ machineList.machineName }}</span>
            <el-divider></el-divider>
          </div>
          <div class="wrap-li">
            <span class="title">Beauty Center:</span>
            <span class="message">{{ machineList.attribution }}</span>
            <el-divider></el-divider>
          </div>
          <div class="wrap-li">
            <span class="title">Rental Time:</span>
            <span class="message">{{ machineList.rentalTime }}</span>
            <el-divider></el-divider>
          </div>
          <div class="wrap-li">
            <span class="title">Creation Time:</span>
            <span class="message">{{ machineList.creationTime }}</span>
            <el-divider></el-divider>
          </div>
          <div class="wrap-li">
            <span class="title">Last Online Time:</span>
            <span class="message">{{ machineList.lastOnlineTime }}</span>
            <el-divider></el-divider>
          </div>
          <div class="wrap-li">
            <span class="title">Status:</span>
            <span class="message">{{ machineList.status }}</span>
            <el-divider></el-divider>
          </div>
        </div>
      </el-card>
    </el-container>
    <el-container>
      <el-card class="box-card" style="width:100%;">
        <div slot="header" class="clearfix">
          <span>Treatment History </span>
          <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
        </div>
        <div class="text item">
          <!--列表-->
          <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="Loading..." style="width: 100%;">
            <el-table-column align="center" type="index" width="44"></el-table-column>
            <el-table-column align="center" prop="firstName" label="First Name" width="144"></el-table-column>
            <el-table-column align="center" prop="lastName" label="Last Name" width="144"></el-table-column>
            <el-table-column align="center" prop="sex" label="Gender" width="144"></el-table-column>
            <el-table-column align="center" prop="mode" label="Treatment Type" width="144">
              <!-- <template slot-scope="scope">
                <div>{{scope.row.editTime|timestampToTime}}</div>
              </template> -->
            </el-table-column>
            <el-table-column align="center" prop="skinType" label="Skin Type" width="144"></el-table-column>
            <el-table-column align="center" prop="fluence" label="Fluence" width="144"></el-table-column>
            <el-table-column align="center" prop="pulse" label="Pulse" width="144"></el-table-column>
            <el-table-column align="center" prop="frequency" label="Frequency" width="144"></el-table-column>
            <el-table-column align="center" prop="cooling" label="Cooling" width="144"></el-table-column>
            <el-table-column align="center" prop="counter" label="Shots" width="144"></el-table-column>
            <el-table-column align="center" prop="status" label="Status" width="144"></el-table-column>
            <el-table-column align="center" prop="creationTime" label="creationTime" width="144"></el-table-column>
          </el-table>
          <!-- 分页组件 -->
          <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </div>
      </el-card>
    </el-container>
    <!-- 修改参数 -->
    <el-dialog title="Parameters Setting" :visible.sync="parametersFormVisible" width="60%" @click="closeDialog">
      <el-form style="padding-bottom: 20px;" :inline="true" :model="realTimeForminline" class="user-search">
        <div id="realTime-bg">
          <img :src="pararm_imgsrc" width="100%" />
          <div v-show="showMenuBtn" class="menu_btn">
            <span class="hrm_btn" @click="showHrmSkin"></span>
            <span class="hrs_btn" @click="showHrs"></span>
            <span class="stm_btn" @click="showStm"></span>
          </div>
          <div v-show="showHrmMenu" class="hrm_menu">
            <div :class="upClass" @click="up"></div>
            <div :class="downClass" @click="down"></div>
            <div :class="backClass" @click="back('HRM')"></div>
            <p v-show="pararm_showFluence" :class="pararm_fluenceClass">{{pararm_fluence}}</p>
            <div :class="confirmClass" @click="saveChang"></div>
          </div>
          <div v-show="showHrsMenu" class="hrs_menu">
            <div :class="upClass" @click="up"></div>
            <div :class="downClass" @click="down"></div>
            <div :class="backClass" @click="back('HRS')"></div>
            <p v-show="pararm_showFluence" :class="pararm_fluenceClass" @click="changContent('fluence')">{{pararm_fluence}}</p>
            <p v-show="pararm_showPulse" :class="pararm_pulseClass" @click="changContent('pulse')">{{pararm_pulse}}</p>
            <p v-show="pararm_showFrequency" :class="pararm_frequencyClass" @click="changContent('frequency')">{{pararm_frequency}}</p>
            <p v-show="pararm_showCooling" :class="pararm_coolingClass" @click="changContent('cooling')">{{pararm_cooling}}</p>
            <div :class="confirmClass" @click="saveChang"></div>
          </div>
          <div v-show="showSrsmMenu">
            <div :class="upClass" @click="up"></div>
            <div :class="downClass" @click="down"></div>
            <div class="srsm_skinType">
              <div class="type6" @click="clickType('6',$event)"></div>
              <div class="type5" @click="clickType('5',$event)"></div>
              <div class="type4" @click="clickType('4',$event)"></div>
              <div class="type3" @click="clickType('3',$event)"></div>
              <div class="type2" @click="clickType('2',$event)"></div>
              <div class="type1" @click="clickType('1',$event)"></div>
            </div>
            <p v-show="pararm_showFluence" :class="pararm_fluenceClass" @click="changContent('fluence')">{{pararm_fluence}}</p>
            <p v-show="pararm_showPulse" :class="pararm_pulseClass" @click="changContent('pulse')">{{pararm_pulse}}</p>
            <p v-show="pararm_showFrequency" :class="pararm_frequencyClass" @click="changContent('frequency')">{{pararm_frequency}}</p>
            <div :class="confirmClass" @click="saveChang"></div>
            <div :class="backClass" @click="back('SRSM')"></div>
          </div>
          <div v-show="showSrmmMenu">
            <div :class="upClass" @click="up"></div>
            <div :class="downClass" @click="down"></div>
            <div class="srmm_skinType">
              <div class="type6" @click="clickType('6',$event)"></div>
              <div class="type5" @click="clickType('5',$event)"></div>
              <div class="type4" @click="clickType('4',$event)"></div>
              <div class="type3" @click="clickType('3',$event)"></div>
              <div class="type2" @click="clickType('2',$event)"></div>
              <div class="type1" @click="clickType('1',$event)"></div>
            </div>
            <p v-show="pararm_showFluence" :class="pararm_fluenceClass" @click="changContent('fluence')">{{pararm_fluence}}</p>
            <p v-show="pararm_showPulse" :class="pararm_pulseClass" @click="changContent('pulse')">{{pararm_pulse}}</p>
            <p v-show="pararm_showFrequency" :class="pararm_frequencyClass" @click="changContent('frequency')">{{pararm_frequency}}</p>
            <div :class="confirmClass" @click="saveChang"></div>
            <div :class="backClass" @click="back('SRMM')"></div>
          </div>
          <div v-show="showStmMenu" class='stm_menu'>
            <div class="srsm_menu" @click="showSrsm"></div>
            <div class="srmm_menu" @click="showSrmm"></div>
            <div :class="backClass" @click="back('STM')"></div>
          </div>
          <div v-show="showHrmSkinMenu" class='hrmSkin_menu'>
            <div class="hrmSkin_option" @click="showHrm('1')"></div>
            <div class="hrmSkin_option" @click="showHrm('2')"></div>
            <div class="hrmSkin_option" @click="showHrm('3')"></div>
            <div class="hrmSkin_option" @click="showHrm('4')"></div>
            <div class="hrmSkin_option" @click="showHrm('5')"></div>
            <div class="hrmSkin_option" @click="showHrm('6')"></div>
            <div :class="backClass" @click="back('SKIN')"></div>
          </div>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import {getChat, saveChat, getMachineData, getHistory, getRealTime, saveRealTime } from "@/api/userMG";
import Pagination from '@/components/Pagination'
export default {
  name: "chat",
  props: ['childMsg'],
  data() {
    return {
      timer: null,
      loginUser: JSON.parse(localStorage.getItem('userdata'))._source.authority,
      chatVisible: true,
      loading:false,
      scrollDisabled: false,
      parametersFormVisible: false,
      changFormVisible: false,
      fluenceFormVisible: false,
      frequencyFormVisible: false,
      pulseFormVisible: false,
      coolingFormVisible: false,
      fluenceClass: 'fluence',
      pulseClass: 'pulse',
      frequencyClass: 'frequency',
      coolingClass: 'cooling',
      upClass: '',
      downClass: '',
      backClass: '',
      confirmClass: '',
      showFluence: false,
      showPulse: false,
      showFrequency: false,
      showCooling: false,
      showMenuBtn: true,
      showHrmMenu: false,
      showHrsMenu: false,
      showSrsmMenu: false,
      showSrmmMenu: false,
      showHrmSkinMenu: false,
      showStmMenu: false,
      pararm_showFluence: false,
      pararm_showPulse: false,
      pararm_showFrequency: false,
      pararm_showCooling: false,
      pararm_option: null,
      pararm_mode: '',
      pararm_skinType: '0',
      pararm_fluence: 5,
      pararm_pulse: 30,
      pararm_frequency: 1,
      pararm_cooling: 0,
      pararm_fluenceClass: 'pararm_fluence',
      pararm_pulseClass: 'pararm_pulse',
      pararm_frequencyClass: 'pararm_frequency',
      pararm_coolingClass: 'pararm_cooling',
      imgsrc: require('../assets/img/zhujiemian.jpg'),
      pararm_imgsrc: require('../assets/img/zhujiemian.jpg'),
      defualtAvatar: '', // 后端没有返回头像默认头像，注意：需要用require请求方式才能动态访问本地文件
      data:[],
      distincData:[], // 消息去重数组
      machineList: {},
      listData: [],
      changParmNum: '',
      changStep: 1,
      num: 1,
      fluenceMin: 0,
      fluenceMax: 100,
      frequencyMin: 0,
      frequencyMax: 10,
      status: null,
      editNow: false,
      mode: 'HRS',
      fluence: {title: 'fluence',num: 0},
      pulse: {title: 'pulse',num: 0},
      frequency: {title: 'frequency',num: 0},
      cooling: {title: 'cooling',num: 0},
      skinType: ['face-color-1', 'face-color-2', 'face-color-3', 'face-color-4', 'face-color-5', 'face-color-6'],
      checkbox: '1',
      offsetMax:0, // 最大偏移位，记录当前获取的最大id，往后的定时轮询数据时每次只获取比这个id大的数据
      offsetMin:0,  // 最小偏移位，记录当前获取的最小id，往上滑动时每次只获取比这小id大的数据
      searchForm:{ // 每次定时获取数据或首次加载数据提交的form表单数据
        pageNumber: 1,
        pageSize: 20
      },
      form:{ // 发送数据提交数据表单
        content:"",
        msg:""
      },
      timerSwitch:0 ,// 定时器开关，默认关闭,
      input: '',
      count: 0,
      chatForminline: {
        page: 10,
        msgId: '',
        sender: '',
        content: '',
        nickName: '',
        userCode: ''
      },
      machineForminline: {
        page: 1,
        serialNumber: '',
        machineName: '',
        belonging: JSON.parse(localStorage.getItem('userdata'))._source.account !== 'admin' ? JSON.parse(localStorage.getItem('userdata'))._source.belonging : '',
        attribution: JSON.parse(localStorage.getItem('userdata'))._source.account !== 'admin' ? JSON.parse(localStorage.getItem('userdata'))._source.belonging : '',
        assignBelongingText: '',
        status: '',
        rentalTime: '',
        version: '',
        creationTime: '',
        lastOnlineTime: ''
      },
      patientForminline: {
        page: 1,
        firstName: '',
        lastName: '',
        belonging: JSON.parse(localStorage.getItem('userdata'))._source.account !== 'admin' ? JSON.parse(localStorage.getItem('userdata'))._source.belonging : '',
        mode: '',
        operator: '',
        creationTime: ''
      },
      realTimeForminline: {
        serialNumber: '',
        belonging: JSON.parse(localStorage.getItem('userdata'))._source.account !== 'admin' ? JSON.parse(localStorage.getItem('userdata'))._source.belonging : '',
      },
      // 分页参数
      pageparm: {
        page: 1,
        size: 10,
        total: 10
      },
      chatData: [],
      user: JSON.parse(localStorage.getItem('userdata'))._source.account
    };
  },
  // 注册组件
  components: {
    Pagination
  },
  created(){
    if(this.loginUser !== 'Super administrator'){
      this.machineForminline.belonging = JSON.parse(localStorage.getItem('userdata'))._source.belonging
      this.patientForminline.belonging = JSON.parse(localStorage.getItem('userdata'))._source.belonging
    }

    this.chatForminline.msgId = this.$route.query.SN;
    this.machineForminline.serialNumber = this.$route.query.SN;
    this.realTimeForminline.serialNumber = this.$route.query.SN;
    this.getRealTimeData(this.realTimeForminline);
    this.getChatData(this.chatForminline);
    this.getMachineList(this.machineForminline);

    console.log(this.machineForminline,'^^^^^^^^^^^^^^^^^^^^^^^^^^');
  },
  mounted(){
     this.timer = setInterval(() => {
         setTimeout(()=>{
          this.chatForminline.msgId = this.$route.query.SN;
          this.machineForminline.serialNumber = this.$route.query.SN;
          this.realTimeForminline.serialNumber = this.$route.query.SN;
          this.getRealTimeData(this.realTimeForminline);
          this.getChatData(this.chatForminline);
          this.getMachineList(this.machineForminline);
         }, 0)
     }, 1000*30)
  },
  methods: {
    init(){

    },
    load () {
      this.chatForminline.page = this.chatForminline.page + 4
      this.getChatData(this.chatForminline);
    },
    getRealTimeData(parameter){
      getRealTime(parameter)
        .then(res => {
          if(res.code === 201){
            this.mode = res.data[0].mode;
            this.fluence.num = res.data[0].fluence;
            this.pulse.num = res.data[0].pulse;
            this.frequency.num = res.data[0].frequency;
            this.cooling.num = res.data[0].cooling;
            this.checkbox = res.data[0].skinType;
            this.realTimeForminline.updateId = res.data[0].id;
            this.patientForminline.firstName = res.data[0].firstName;
            this.patientForminline.lastName = res.data[0].lastName;
            this.status = res.data[0].status;
            this.max = 0;
            if(this.mode === 'MENU'){
              this.imgsrc = require('../assets/img/zhujiemian.jpg')
            }
            if(this.mode === 'HRS'){
              this.imgsrc = require('../assets/img/hrs.jpg')
              this.showFluence = true;
              this.showPulse = true;
              this.showFrequency = true;
              this.showCooling = true;
            }
            if(this.mode === 'HRS' && this.status === 'READY'){
              this.imgsrc = require('../assets/img/hrs2.jpg')
              this.showFluence = true;
              this.showPulse = true;
              this.showFrequency = true;
              this.showCooling = true;
            }
            if(this.mode === 'SKIN'){
              this.imgsrc = require('../assets/img/hrmskin.jpg')
            }
            if(this.mode === 'SKIN'){
              this.imgsrc = require('../assets/img/hrmskin.jpg')
            }
            if(this.mode === 'HRM'){
              this.imgsrc = require('../assets/img/hrm.jpg')
              this.fluenceClass = 'hrm_fluence';
              this.showFluence = true;
              this.showPulse = false;
              this.showFrequency = false;
              this.showCooling = false;
            }
            if(this.mode === 'HRM' && this.status === 'READY'){
              this.imgsrc = require('../assets/img/hrm2.jpg')
            }
            if(this.mode === 'STM'){
              this.imgsrc = require('../assets/img/stm.jpg')
            }
            if(this.mode === 'SRSM'){
              this.imgsrc = require('../assets/img/srsm.jpg')
              this.fluenceClass = 'srsm_fluence';
              this.pulseClass = 'srsm_pulse';
              this.frequencyClass = 'srsm_frequency';
              this.showFluence = true;
              this.showPulse = true;
              this.showFrequency = true;
            }
            if(this.mode === 'SRSM' && this.status === 'READY'){
              this.imgsrc = require('../assets/img/srsm2.jpg')
            }
            if(this.mode === 'SRMM'){
              this.imgsrc = require('../assets/img/srmm.jpg')
              this.fluenceClass = 'srmm_fluence';
              this.pulseClass = 'srmm_pulse';
              this.frequencyClass = 'srmm_frequency';
              this.showFluence = true;
              this.showPulse = true;
              this.showFrequency = true;
            }
            if(this.mode === 'SRMM' && this.status === 'READY'){
              this.imgsrc = require('../assets/img/srmm2.jpg')
            }
            this.getPatientList(this.patientForminline);
          }
        })
        .catch(err => {
          this.$message.error("There are no patients being treated on this device!");
        })
    },
    getChatData(parameter){
      getChat(parameter)
        .then(res=>{
          if(res.code === 201){
            this.chatData = res.data;
            this.chatForminline.page = res.page
            if(res.page >= res.total){
              this.scrollDisabled = true;
            }
          }
        })
        .catch(err=>{
          console.log(err);
        })
    },
    getMachineList(parameter){
      getMachineData(parameter)
        .then(res => {
          if(res.code === 201){
            this.machineList = res.data[0];
            console.log(res,'@@@@@@@@@@@@@@@@@@@');
            console.log(this.listData,'$$$$$$$$$$$$$$');
          }
        })
        .catch(err => {
          console.log(err);
        })
    },
    getPatientList(parameter){
      this.loading = true
      getHistory(parameter)
        .then(res => {
          if(res.code === 201){
            this.loading = false
            this.listData = res.data;
            this.pageparm.total = res.total;
            this.pageparm.page = res.page;
            console.log(res);
          }
        })
        .catch(err => {
          console.log(err);
        })
    },
    sendMsg(){ // 发送消息
      this.loading = true;
      if(!this.chatForminline.content){
         this.loading = false;
         this.$message.warning("You cannot send blank messages!");
        return;
      }

      var date = new Date();
      var hour = date.getHours();
      date.setHours(hour + 2)
      var time = date.toISOString()
      console.log(time);
      this.chatForminline.msgId = this.$route.query.SN;
      this.chatForminline.sender = JSON.parse(localStorage.getItem('userdata'))._source.account
      this.chatForminline.nickName = JSON.parse(localStorage.getItem('userdata'))._source.account
      this.chatForminline.userCode = time
      this.chatForminline.status = 'false'
      saveChat(this.chatForminline)
        .then(res => {
          if(res.code === 201){
            setTimeout(()=>{
              this.loading = false;
              this.getChatData(this.chatForminline);
              this.chatForminline.content = '';
            },800)
          }
        })
        .catch(err => {
          this.loading = false;
          setTimeout(()=>{
            this.loading = false;
            this.$message.error("Sending failed. Please try again later!");
          },800)

        })
    },
    saveChang(){
      var date = new Date();
      var hour = date.getHours();
      date.setHours(hour + 2)
      var time = date.toISOString()
      this.loading = true;
      this.realTimeForminline.mode = this.pararm_mode;
      this.realTimeForminline.fluence = this.pararm_fluence;
      this.realTimeForminline.pulse = this.pararm_pulse;
      this.realTimeForminline.frequency = this.pararm_frequency;
      this.realTimeForminline.cooling = this.pararm_cooling;
      this.realTimeForminline.skinType = this.pararm_skinType;
      this.realTimeForminline.inputting = 'true';
      this.realTimeForminline.updatetime = time;
      saveRealTime(this.realTimeForminline)
        .then(res => {
          if(res.code === 201){
            var obj = {serialNumber:this.$route.query.SN}
            setTimeout(()=>{
              this.loading = false;
              this.parametersFormVisible = false;
              this.editNow = false;
              this.showMenuBtn = true,
              this.showHrmMenu = false,
              this.showHrsMenu = false,
              this.showSrsmMenu = false,
              this.showSrmmMenu = false,
              this.showHrmSkinMenu = false,
              this.showStmMenu = false,
              this.pararm_imgsrc = require('../assets/img/zhujiemian.jpg');
              this.getRealTimeData(obj);
            },800)
          }
        })
        .catch(err => {
          this.loading = false;
          setTimeout(()=>{
            this.loading = false;
            this.$message.error("数据修改失败,请稍后再试");
          },800)

        })
      console.log(this.realTimeForminline);
    },
    checkHistory(index, row){
      this.parametersFormVisible = true;
      this.title = 'Parameters Setting';
    },
    modifyParameters(){
      this.parametersFormVisible = true;
      this.title = 'Parameters Setting';
      this.max = Number(this.fluence.num);
      // var obj = {
      //   updateId : this.realTimeForminline.updateId,
      //   inputting : 'true'
      // }
      // saveRealTime(obj)
      //   .then(res => {
      //     if(res.code === 201){
      //       console.log(obj);
      //       console.log('success');
      //     }
      //   })
      console.log(this.fluence,'@@@@@@@@@@@@@@@@@');
    },
    scrollToBottom: function(){ // 滚动到窗体底部
      this.$nextTick(()=>{
          let chatform = document.querySelector(".infinite-list");
          var height = chatform.scrollHeight;
          chatform.scrollTop = height;
      });
    },
    // 关闭弹出框
    closeDialog() {
      this.pararm_imgsrc = require('../assets/img/zhujiemian.jpg');
      this.historyFormVisible = false;
      this.parametersFormVisible = false;
      this.editNow = false;
    },
    // 分页插件事件
    callFather(parm) {
      this.patientForminline.page = parm.currentPage
      this.getPatientList(this.patientForminline)
    },
    handleChange(value) {
      console.log(value);
    },
    changContent(parm){
      this.pararm_option = parm;
      if(this.mode !== 'HRM' && parm === 'pulse'){
        this.changFormVisible = true;
        this.pulseFormVisible = true;
        this.fluenceFormVisible = false;
        this.frequencyFormVisible = false;
        this.coolingFormVisible = false;

      }
      if(parm === 'pulse'){
        this.pulseMin = 30;
        this.pulseMax = 300;
      }
      // if(this.mode === 'HRM' && parm === 'fluence'){
          // this.fluenceMin = 5;
          // this.fluenceMax = 12;
          // this.changStep = 1;
        // this.$message.error("此模式无法设置" + parm);
      // }
      if(parm === 'fluence'){
        this.fluenceFormVisible = true;
        this.pulseFormVisible = false;
        this.frequencyFormVisible = false;
        this.coolingFormVisible = false;

        if(this.pararm_pulse == 30){
          this.fluenceMin = 5;
          this.fluenceMax = 12;
          this.changStep = 1;
        }
        if(this.pararm_pulse == 50){
          this.fluenceMin = 5;
          this.fluenceMax = 15;
          this.changStep = 1;
        }
        if(this.pararm_pulse == 80){
          this.pararm_fluence = 6;
          this.fluenceMin = 6;
          this.fluenceMax = 24;
          this.changStep = 2;
        }
        if(this.pararm_pulse == 100){
          this.pararm_fluence = 6;
          this.fluenceMin = 6;
          this.fluenceMax = 28;
          this.changStep = 2;
        }
        if(this.pararm_pulse == 200 || this.pararm_pulse == 300){
          this.pararm_fluence = 10;
          this.fluenceMin = 10;
          this.fluenceMax = 40;
          this.changStep = 2;
        }
      }
      if(this.mode !== 'HRM' && parm === 'cooling'){
        this.coolingFormVisible = true;
        this.pulseFormVisible = false;
        this.fluenceFormVisible = false;
        this.frequencyFormVisible = false;
      }
      if(this.mode !== 'HRM' && parm === 'frequency'){
        this.frequencyFormVisible = true;
        this.pulseFormVisible = false;
        this.fluenceFormVisible = false;
        this.coolingFormVisible = false;
        if(this.pararm_pulse == 30){
          this.frequencyMin = 1;
          this.frequencyMax = 12;
          this.changStep = 1;
        }
        if(this.pararm_pulse == 50){
          this.frequencyMin = 1;
          this.frequencyMax = 8;
          this.changStep = 1;
        }
        if(this.pararm_pulse == 80){
          this.frequencyMin = 1;
          this.frequencyMax = 5;
          this.changStep = 1;
        }
        if(this.pararm_pulse == 100){
          this.frequencyMin = 1;
          this.frequencyMax = 4;
          this.changStep = 1;
        }
        if(this.pararm_pulse == 200){
          this.frequencyMin = 1;
          this.frequencyMax = 2;
          this.changStep = 1;
        }
        if(this.pararm_pulse == 300){
          this.frequencyMin = 1;
          this.frequencyMax = 1;
          this.changStep = 1;
        }
      }
      console.log(parm);
    },
    showStm(){
      this.backClass = 'stmBack';
      this.showMenuBtn = false;
      this.showStmMenu = true;
      this.pararm_imgsrc = require('../assets/img/stm.jpg');
    },
    showHrm(type){
      this.backClass = 'hrmBack';
      this.upClass = 'hrmUp';
      this.downClass = 'hrmDown';
      this.confirmClass = 'hrmConfirm';
      this. pararm_fluenceClass= 'hrm_pararm_fluence';
      this.pararm_mode = 'HRM';
      this.showMenuBtn = false;
      this.showHrmSkinMenu = false;
      this.showHrmMenu = true;
      this.pararm_showFluence = true;
      this.pararm_imgsrc = require('../assets/img/hrm.jpg');
      this.pararm_skinType = type;
      if(type === '1'){
        this.fluenceMin = 5;
        this.fluenceMax = 12;
        this.changStep = 1;
      }
      if(type === '2'){
        this.fluenceMin = 5;
        this.fluenceMax = 11;
        this.changStep = 1;
      }
      if(type === '3'){
        this.fluenceMin = 5;
        this.fluenceMax = 10;
        this.changStep = 1;
      }
      if(type === '4'){
        this.fluenceMin = 5;
        this.fluenceMax = 9;
        this.changStep = 1;
      }
      if(type === '5'){
        this.fluenceMin = 5;
        this.fluenceMax = 8;
        this.changStep = 1;
      }
      if(type === '6'){
        this.fluenceMin = 5;
        this.fluenceMax = 7;
        this.changStep = 1;
      }
    },
    showHrmSkin(){
      this.backClass = 'skinBack'
      this.pararm_mode = 'SKIN';
      this.showMenuBtn = false;
      this.showHrmSkinMenu = true;
      this.pararm_imgsrc = require('../assets/img/hrmskin.jpg');
    },
    showHrs(){
      this.backClass = 'hrsBack'
      this.upClass = 'hrsUp';
      this.downClass = 'hrsDown';
      this.confirmClass = 'hrsConfirm';
      this. pararm_fluenceClass= 'hrs_pararm_fluence';
      this. pararm_pulseClass= 'hrs_pararm_pulse';
      this. pararm_frequencyClass= 'hrs_pararm_frequency';
      this. pararm_coolingClass= 'hrs_pararm_cooling';
      this.pararm_mode = 'HRS';
      this.showMenuBtn = false;
      this.showHrsMenu = true;
      this.pararm_showFluence = true;
      this.pararm_showPulse = true;
      this.pararm_showFrequency = true;
      this.pararm_showCooling = true;
      this.pararm_imgsrc = require('../assets/img/hrs.jpg');
    },
    showSrsm(){
      this.pararm_mode = 'SRSM';
      this.backClass = 'srsmBack'
      this.upClass = 'srsmUp';
      this.downClass = 'srsmDown';
      this.confirmClass = 'srsmConfirm';
      this. pararm_fluenceClass= 'srsm_pararm_fluence';
      this. pararm_pulseClass= 'srsm_pararm_pulse';
      this. pararm_frequencyClass= 'srsm_pararm_frequency';
      this.showMenuBtn = false;
      this.showStmMenu = false;
      this.pararm_showFluence = true;
      this.pararm_showPulse = true;
      this.pararm_showFrequency = true;
      this.showSrsmMenu = true;
      this.pararm_imgsrc = require('../assets/img/srsm.jpg');
    },
    showSrmm(){
      this.pararm_mode = 'SRMM';
      this.backClass = 'srmmBack'
      this.upClass = 'srmmUp';
      this.downClass = 'srmmDown';
      this.confirmClass = 'srmmConfirm';
      this. pararm_fluenceClass= 'srmm_pararm_fluence';
      this. pararm_pulseClass= 'srmm_pararm_pulse';
      this. pararm_frequencyClass= 'srmm_pararm_frequency';
      this.showMenuBtn = false;
      this.showStmMenu = false;
      this.pararm_showFluence = true;
      this.pararm_showPulse = true;
      this.pararm_showFrequency = true;
      this.showSrmmMenu = true;
      this.pararm_imgsrc = require('../assets/img/srmm.jpg');
    },
    up(){
      if(this.pararm_mode === 'HRM'){
        if(this.pararm_fluence < this.fluenceMax){
          this.pararm_fluence = this.pararm_fluence + this.changStep;
        }
        console.log(this.pararm_fluence);
      }
      if(this.pararm_mode === 'HRS'){
        console.log(this.pararm_option);
        if(this.pararm_option === 'pulse'){
          if(this.pararm_pulse < this.pulseMax){
            if(this.pararm_pulse == 30 || this.pararm_pulse == 80){
              this.changStep = 20;
            }
            if(this.pararm_pulse == 50){
              this.changStep = 30;
            }
            if(this.pararm_pulse >= 100){
              this.changStep = 100;
            }
            this.pararm_pulse = this.pararm_pulse + this.changStep;
          }
        }
        if(this.pararm_option === 'fluence'){
          console.log(this.pararm_fluence);
          if(Number(this.pararm_fluence) < this.fluenceMax){
            this.pararm_fluence = this.pararm_fluence + this.changStep;
          }
        }
        if(this.pararm_option === 'frequency'){
          console.log(this.pararm_frequency);
          if(this.pararm_frequency < this.frequencyMax){
            this.pararm_frequency = this.pararm_frequency + this.changStep;
          }
        }
        if(this.pararm_option === 'cooling'){
          console.log(this.pararm_cooling);
          if(this.pararm_cooling < 5){
            this.pararm_cooling = this.pararm_cooling + 1;
          }
        }
      }
      if(this.pararm_mode === 'SRSM' || this.pararm_mode === 'SRMM'){
        console.log(this.pulseMax);
        if(this.pararm_option === 'pulse'){
          if(this.pararm_pulse < this.pulseMax){
            if(this.pararm_pulse == 30 || this.pararm_pulse == 80){
              this.changStep = 20;
            }
            if(this.pararm_pulse == 50){
              this.changStep = 30;
            }
            if(this.pararm_pulse >= 100){
              this.changStep = 100;
            }
            this.pararm_pulse = this.pararm_pulse + this.changStep;
          }
        }
        if(this.pararm_option === 'fluence'){
          if(this.pararm_fluence < this.fluenceMax){
            this.pararm_fluence = this.pararm_fluence + this.changStep;
          }
          console.log(this.pararm_fluence);
        }
        if(this.pararm_option === 'frequency'){
          console.log(this.pararm_frequency);
          if(this.pararm_frequency < this.frequencyMax){
            this.pararm_frequency = this.pararm_frequency + this.changStep;
          }
        }
      }
    },
    down(){
      if(this.pararm_mode === 'HRM'){
        if(this.pararm_fluence > this.fluenceMin){
          this.pararm_fluence = this.pararm_fluence - this.changStep;
        }
        console.log(this.pararm_fluence);
      }
      if(this.pararm_mode === 'HRS'){
        if(this.pararm_option === 'pulse'){
          if(this.pararm_pulse > this.pulseMin){
            if(this.pararm_pulse == 80){
              this.changStep = 30;
            }
            if(this.pararm_pulse == 50){
              this.changStep = 20;
            }
            if(this.pararm_pulse == 100){
              this.changStep = 20;
            }
            if(this.pararm_pulse > 100){
              this.changStep = 100;
            }
            this.pararm_pulse = this.pararm_pulse - this.changStep;
          }
        }
        if(this.pararm_option === 'fluence'){
          if(this.pararm_fluence > this.fluenceMin){
            this.pararm_fluence = this.pararm_fluence - this.changStep;
          }
          console.log(this.pararm_fluence);
        }
        if(this.pararm_option === 'frequency'){
          console.log(this.pararm_frequency);
          if(this.pararm_frequency > this.frequencyMin){
            this.pararm_frequency = this.pararm_frequency - this.changStep;
          }
        }
        if(this.pararm_option === 'cooling'){
          console.log(this.pararm_cooling);
          if(this.pararm_cooling > 0){
            this.pararm_cooling = this.pararm_cooling - 1;
          }
        }
      }
      if(this.pararm_mode === 'SRSM' || this.pararm_mode === 'SRMM'){
        if(this.pararm_option === 'pulse'){
          if(this.pararm_pulse > this.pulseMin){
            if(this.pararm_pulse == 80){
              this.changStep = 30;
            }
            if(this.pararm_pulse == 50){
              this.changStep = 20;
            }
            if(this.pararm_pulse == 100){
              this.changStep = 20;
            }
            if(this.pararm_pulse > 100){
              this.changStep = 100;
            }
            this.pararm_pulse = this.pararm_pulse - this.changStep;
          }
        }
        if(this.pararm_option === 'fluence'){
          if(this.pararm_fluence > this.fluenceMin){
            this.pararm_fluence = this.pararm_fluence - this.changStep;
          }
          console.log(this.pararm_fluence);
        }
        if(this.pararm_option === 'frequency'){
          console.log(this.pararm_frequency);
          if(this.pararm_frequency > this.frequencyMin){
            this.pararm_frequency = this.pararm_frequency - this.changStep;
          }
        }
      }
    },
    back(parm){
      if(parm === 'HRM'){
        this.backClass = 'skinBack';
        this.showHrmMenu = false;
        this.pararm_showFluence = false;
        this.showHrmSkinMenu = true;
        this.pararm_imgsrc = require('../assets/img/hrmskin.jpg');
      }
      if(parm === 'SKIN'){
        this.showHrmMenu = false;
        this.pararm_showFluence = false;
        this.showHrmSkinMenu = false;
        this.showMenuBtn = true;
        this.pararm_imgsrc = require('../assets/img/zhujiemian.jpg');
      }
      if(parm === 'HRS'){
        this.showHrmMenu = false;
        this.pararm_showFluence = false;
        this.pararm_showPulse = false;
        this.pararm_showFrequency= false;
        this.pararm_showCooling = false;
        this.showHrsMenu = false;
        this.showMenuBtn = true;
        this.pararm_imgsrc = require('../assets/img/zhujiemian.jpg');
      }
      if(parm === 'STM'){
        this.showHrmMenu = false;
        this.pararm_showFluence = false;
        this.pararm_showPulse = false;
        this.pararm_showFrequency= false;
        this.pararm_showCooling = false;
        this.showHrsMenu = false;
        this.showStmMenu = false;
        this.showMenuBtn = true;
        this.pararm_imgsrc = require('../assets/img/zhujiemian.jpg');
      }
      if(parm === 'SRSM'){
        this.backClass = 'stmBack';
        this.showHrmMenu = false;
        this.pararm_showFluence = false;
        this.pararm_showPulse = false;
        this.pararm_showFrequency= false;
        this.pararm_showCooling = false;
        this.showHrsMenu = false;
        this.showStmMenu = true;
        this.showSrsmMenu = false
        this.showMenuBtn = true;
        this.pararm_imgsrc = require('../assets/img/stm.jpg');
      }
      if(parm === 'SRMM'){
        this.backClass = 'stmBack';
        this.showHrmMenu = false;
        this.pararm_showFluence = false;
        this.pararm_showPulse = false;
        this.pararm_showFrequency= false;
        this.pararm_showCooling = false;
        this.showHrsMenu = false;
        this.showStmMenu = true;
        this.showSrmmMenu = false
        this.showMenuBtn = true;
        this.pararm_imgsrc = require('../assets/img/stm.jpg');
      }
    },
    clickType(type,e){
      this.pararm_skinType = type;
      e.target.style.border = "2px solid skyblue";
    }
  },
  beforeDestroy(){
     clearInterval(this.timer);
     this.timer = null;
  },
  updated(){
     this.scrollToBottom();
  }
};
</script>

<style scoped>
  .menu_btn{
    position: absolute;
    bottom: 18%;
    left: 0;
    right: 0;
  }
  .hrm_btn,.hrs_btn,.stm_btn{
    display: inline-block;
    width: 140px;
    height: 54px;
    cursor: pointer;
    /* border: 2px solid #1F2D3D; */
  }
  .hrm_btn{
    margin-left: 6%;
  }
  .hrs_btn{
    margin-left: 4%;
  }
  .stm_btn{
    margin-left: 3%;
  }
  .hrmUp,.hrsUp,.srsmUp,.srmmUp,.hrmDown,.hrsDown,.srsmDown,.srmmDown,.hrmBack,.skinBack,.hrsBack,.srsmBack,.srmmBack,.hrmConfirm,.hrsConfirm,.srsmConfirm,.srmmConfirm{
    position: absolute;
    width: 100px;
    height: 100px;
    cursor: pointer;
    /* border: 2px solid #1F2D3D; */
  }
  .hrmUp{
    top: 20%;
    left: 5%;
  }
  .hrsUp{
    bottom: 6%;
    left: 5%;
  }
  .srsmUp{
    bottom: 6%;
    left: 4%;
  }
  .srmmUp{
    bottom: 5%;
    left: 4%;
  }
  .hrmDown{
    top: 55%;
    left: 5%;
  }
  .hrsDown{
    bottom: 6%;
    left: 20%;
  }
  .srsmDown{
    bottom: 6%;
    left: 19%;
  }
  .srmmDown{
    bottom: 5%;
    left: 19%;
  }
  .hrmBack{
    bottom: 25%;
    right: 5%;
  }
  .skinBack{
    bottom: -21%;
    right: 19%;
    width: 304px;
    height: 60px;
  }
  .hrsBack{
    bottom: 6%;
    right: 5%;
  }
  .srsmBack{
    bottom: 6%;
    right: 6%;
  }
  .srmmBack{
    bottom: 5%;
    right: 6%;
  }
  .hrmConfirm{
    bottom: 25%;
    right: 21%;
  }
  .hrsConfirm{
    bottom: 6%;
    right: 20%;
  }
  .srsmConfirm{
    bottom: 6%;
    right: 21%;
  }
  .srmmConfirm{
    bottom: 5%;
    right: 21%;
  }
  .hrm_pararm_fluence{
    position: absolute;
    top: -5%;
    left: 23%;
    width: 280px;
    height: 280px;
    text-align: center;
    line-height: 280px;
    font-size: 8rem;
    cursor: pointer;
  }
  .hrmSkin_menu{
    position: absolute;
    top: 9%;
    left: 20%;
    width: 462px;
    font-size: 0;
  }
  .hrmSkin_option{
    display: inline-block;
    margin: 7px 3px;
    width: 140px;
    height: 154px;
    cursor: pointer;
    /* border: 2px solid #1F2D3D; */
  }
  .fluence{
    position: absolute;
    top: 18%;
    left: 16%;
    font-size: 6rem;
  }
  .pulse{
    position: absolute;
    top: 18%;
    left: 46%;
    font-size: 6rem;
  }
  .frequency{
    position: absolute;
    top: 17%;
    left: 76%;
    font-size: 4rem;
  }
  .cooling{
    position: absolute;
    top: 41%;
    left: 76%;
    font-size: 4rem;
  }
  .hrm_fluence{
    position: absolute;
    top: 24%;
    left: 38%;
    font-size: 6rem;
  }
  .srsm_fluence{
    position: absolute;
    top: 15%;
    left: 4%;
    font-size: 6rem;
    width: 200px;
    height: 184px;
    text-align: center;
    line-height: 184px;
  }
  .srmm_fluence{
    position: absolute;
    top: 23%;
    left: 4%;
    font-size: 6rem;
    width: 200px;
    height: 184px;
    text-align: center;
    line-height: 184px;
  }
  .srsm_frequency{
    position: absolute;
    top: 15%;
    left: 35%;
    font-size: 6rem;
    width: 200px;
    height: 184px;
    text-align: center;
    line-height: 184px;
  }
  .srmm_frequency{
    position: absolute;
    top: 23%;
    left: 35%;
    font-size: 6rem;
    width: 200px;
    height: 184px;
    text-align: center;
    line-height: 184px;
  }
  .srsm_pulse{
    position: absolute;
    top: 15%;
    left: 66%;
    font-size: 6rem;
    width: 200px;
    height: 184px;
    text-align: center;
    line-height: 184px;
  }
  .srmm_pulse{
    position: absolute;
    top: 23%;
    left: 66%;
    font-size: 6rem;
    width: 200px;
    height: 184px;
    text-align: center;
    line-height: 184px;
  }
  .hrs_pararm_fluence,.hrs_pararm_pulse{
    position: absolute;
    width: 210px;
    height: 260px;
    font-size: 6rem;
    text-align: center;
    line-height: 260px;
    cursor: pointer;
    /* border: 2px solid #000000; */
  }
  .hrs_pararm_frequency,.hrs_pararm_cooling{
    position: absolute;
    width: 210px;
    height: 122px;
    font-size: 4rem;
    text-align: center;
    line-height: 122px;
    cursor: pointer;
    /* border: 2px solid #000000; */
  }
  .hrs_pararm_fluence{
    top: -5%;
    left: 5%;
  }
  .hrs_pararm_pulse{
    top: -5%;
    left: 36%;
  }
  .hrs_pararm_frequency{
    top: 2%;
    right: 5%;
  }
  .hrs_pararm_cooling{
    top: 29%;
    right: 5%;
  }
  .srsm_menu,.srmm_menu,.stmBack{
    position: absolute;
    width: 134px;
    height: 56px;
    cursor: pointer;
    /* border: 2px solid #1F2D3D; */
  }
  .srsm_menu{
    bottom: 18%;
    left: 6%;
  }
  .srmm_menu{
    bottom: 18%;
    left: 29%;
  }
  .stmBack{
    bottom: 18%;
    right: 6%;
  }
  .srsm_pararm_fluence,.srsm_pararm_pulse,.srsm_pararm_frequency,.srmm_pararm_fluence,.srmm_pararm_pulse,.srmm_pararm_frequency{
    position: absolute;
    width: 210px;
    height: 190px;
    text-align: center;
    line-height: 190px;
    font-size: 6rem;
    cursor: pointer;
    /* border: 2px solid #000000; */
  }

  .srsm_pararm_fluence,.srmm_pararm_fluence{
    top: 15%;
    left: 4%;
  }
  .srsm_pararm_pulse,.srmm_pararm_pulse{
    top: 15%;
    left: 65%;
  }
  .srsm_pararm_frequency,.srmm_pararm_frequency{
    top: 15%;
    left: 35%;
  }
  .srmm_pararm_fluence,.srmm_pararm_pulse,.srmm_pararm_frequency{
    top: 24%;
  }

  .srsm_skinType{
    position: absolute;
    top: 17%;
    left: 4%;
    width: 666px;
    height: 70px;
  }
  .srmm_skinType{
    position: absolute;
    top: 25%;
    left: 4%;
    width: 666px;
    height: 70px;
  }
  .type1,.type2,.type3,.type4,.type5,.type6{
    float: right;
    width: 52px;
    height: 52px;
    margin-top: 8px;
    border: 2px solid #fff;
    cursor: pointer;
  }
  .type6{
    margin-right: 15px;
  }
  .type1,.type4,.type5{
    margin-right: 19px;
  }
  .type2,.type3{
    margin-right: 20px;
  }

  .el-dialog__body{
    padding: 50px 20px;
  }
  .demo-drawer__footer{
    position: absolute;
    bottom: 1%;
    right: 2%;
  }
  #radio-title{
    margin: 10px 0 10px 14px;
  }
  .wrap-li{
    padding: 10px;
    height: 20px;
    line-height: 20px;
  }
  #realTime-bg{
    position: relative;
    width: 100%;
  }
  #changNum{
    position: absolute;
    bottom: 4%;
    left: 50%;
    transform: translateX(-50%);
  }
  #content-wrap{
    height: 384px;
  }
  .infinite-list{
    height: 378px;
    max-height: 378px;
    background-color: #FAFAFA;
  }
  .skinType-wrap{
    position: absolute;
    left: 50%;
    width: 270px;
    transform: translateX(-50%);
  }
  .title{
    float: left;
  }
  .el-radio-button__inner{
    background: #000;
  }
  .message{
    float: right;
  }
  .card-title {
    font-size: 16px;
    font-weight: 500;
    margin-top: 0;
    margin-bottom: 30px;
    text-transform: capitalize;
    color: #222e37;
  }
  .user .content{
    float: left;
    max-width: 240px;
    padding: 6px;
    line-height: 20px;
    border: 1px solid #ccc;
    border-radius: 10px;
    text-align: left;
    word-break:break-all;
    background-color: rgba(0,255,0,.1);
  }
  .myself .content{
    float: right;
    max-width: 240px;
    padding: 6px;
    line-height: 20px;
    border: 1px solid #ccc;
    border-radius: 10px;
    text-align: left;
    word-break:break-all;
    background-color: rgba(0,255,0,.1);
  }
  .user .name{
    display: block;
    padding: 0 4px 0 4px;
    text-align: left;
  }
  .myself .name{
    display: block;
    padding: 0 4px 0 4px;
    text-align: right;
  }
  #email-wrap{
  	position: absolute;
  	top: 0;
  	left: 50%;
    width: 50%;
    height: 350px;
  	transform: translateX(-50%);
  }
  .email-left,.email-right{
  	float: left;
  	display: flex;
  	flex: 1;
    text-align: center;
  }
  .email-left{
    position: absolute;
    top: 18%;
    left: 50%;
    transform: translateX(-50%);
  }
  .email-right{
    position: absolute;
    bottom: -30px;
    left: 50%;
    transform: translateX(-50%);
  }
  .equipment-left,.equipment-right{
  	width: 160px;
  	height: 210px;
  	margin: 0 10px 0 10px;
  	border: 1px solid #999;
  	border-radius: 4px;
  	background-color: rgba(212,246,245,0.9);
    box-shadow: 1px 4px 10px #ccc;
  }
  .equipment-top,.equipment-bottom{
  	width: 160px;
  	height: 100px;
  	margin: 2px 10px 0 10px;
  	border: 1px solid #999;
  	border-radius: 4px;
  	background-color: rgba(212,246,245,0.9);
    box-shadow: 1px 4px 10px #ccc;
  }
  .equipment-left > p{
  	margin: 20px 0
  }
  .equipment-right > p{
  	margin: 20px 0
  }
  .text {
    font-size: 14px;
  }

  .item {
    margin-bottom: 18px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 200px;
  }
  .el-header, .el-footer {
    background-color: #B3C0D1;
    color: #333;
    text-align: center;
    line-height: 60px;
  }

  .el-aside {
    background-color: #D3DCE6;
    color: #333;
    text-align: center;
  }

  .el-main {
    background-color: #E9EEF3;
    color: #333;
    text-align: center;
    line-height: 160px;
  }

  body > .el-container {
    margin-bottom: 40px;
  }


  /* 设置滚动条的样式 */
  ::-webkit-scrollbar {
    width:12px;
  }
  /* 滚动槽 */
  ::-webkit-scrollbar-track {
    -webkit-box-shadow:inset006pxrgba(0,0,0,0.3);
    border-radius:10px;
  }
  /* 滚动条滑块 */
  ::-webkit-scrollbar-thumb {
    border-radius:10px;
    background:rgba(0,0,0,0.1);
    -webkit-box-shadow:inset006pxrgba(0,0,0,0.5);
  }
  ::-webkit-scrollbar-thumb:window-inactive {
    background:rgba(0,0,0,0.4);
  }
  .el-container:nth-child(5) .el-aside,
  .el-container:nth-child(6) .el-aside {
    line-height: 260px;
  }

  .el-container:nth-child(7) .el-aside {
    line-height: 320px;
  }
  @media (max-width: 1700px){
    .menu_btn{
      position: absolute;
      bottom: 18%;
      left: 0;
      right: 0;
    }
    .hrm_btn,.hrs_btn,.stm_btn{
      display: inline-block;
      width: 170px;
      height: 70px;
      cursor: pointer;
      /* border: 2px solid #1F2D3D; */
    }
    .hrm_btn{
      margin-left: 6%;
    }
    .hrs_btn{
      margin-left: 2%;
    }
    .stm_btn{
      margin-left: 3%;
    }
    .hrmUp,.hrsUp,.srsmUp,.srmmUp,.hrmDown,.hrsDown,.srsmDown,.srmmDown,.hrmBack,.skinBack,.hrsBack,.srsmBack,.srmmBack,.hrmConfirm,.hrsConfirm,.srsmConfirm,.srmmConfirm{
      position: absolute;
      width: 120px;
      height: 120px;
      cursor: pointer;
      /* border: 2px solid #1F2D3D; */
    }
    .hrmUp{
      top: 20%;
      left: 5%;
    }
    .hrsUp{
      bottom: 6%;
      left: 5%;
    }
    .srsmUp{
      bottom: 6%;
      left: 4%;
    }
    .srmmUp{
      bottom: 5%;
      left: 4%;
    }
    .hrmDown{
      top: 55%;
      left: 5%;
    }
    .hrsDown{
      bottom: 6%;
      left: 20%;
    }
    .srsmDown{
      bottom: 6%;
      left: 19%;
    }
    .srmmDown{
      bottom: 5%;
      left: 19%;
    }
    .hrmBack{
      bottom: 25%;
      right: 5%;
    }
    .skinBack{
      bottom: -21%;
      right: 19%;
      width: 362px;
      height: 70px;
    }
    .hrsBack{
      bottom: 6%;
      right: 5%;
    }
    .srsmBack{
      bottom: 6%;
      right: 6%;
    }
    .srmmBack{
      bottom: 5%;
      right: 6%;
    }
    .hrmConfirm{
      bottom: 25%;
      right: 21%;
    }
    .hrsConfirm{
      bottom: 6%;
      right: 20%;
    }
    .srsmConfirm{
      bottom: 6%;
      right: 21%;
    }
    .srmmConfirm{
      bottom: 5%;
      right: 21%;
    }
    .hrm_pararm_fluence{
      position: absolute;
      top: 6%;
      left: 23%;
      width: 356px;
      height: 356px;
      text-align: center;
      line-height: 280px;
      font-size: 8rem;
      cursor: pointer;
    }
    .hrmSkin_menu{
      position: absolute;
      top: 9%;
      left: 20%;
      width: 572px;
      height: 436px;
      font-size: 0;
    }
    .hrmSkin_option{
      display: inline-block;
      margin: 7px 3px;
      width: 166px;
      height: 184px;
      cursor: pointer;
      /* border: 2px solid #1F2D3D; */
    }
  .hrs_pararm_fluence,.hrs_pararm_pulse{
    position: absolute;
    width: 270px;
    height: 336px;
    font-size: 6rem;
    text-align: center;
    line-height: 260px;
    cursor: pointer;
    /* border: 2px solid #000000; */
  }
  .hrs_pararm_frequency,.hrs_pararm_cooling{
    position: absolute;
    width: 270px;
    height: 158px;
    font-size: 4rem;
    text-align: center;
    line-height: 122px;
    cursor: pointer;
    /* border: 2px solid #000000; */
  }
  .hrs_pararm_fluence{
    top: 4%;
    left: 5%;
  }
  .hrs_pararm_pulse{
    top: 4%;
    left: 36%;
  }
  .hrs_pararm_frequency{
    top: 8%;
    right: 6%;
  }
  .hrs_pararm_cooling{
    top: 36%;
    right: 6%;
  }
  .srsm_menu,.srmm_menu,.stmBack{
    position: absolute;
    width: 134px;
    height: 56px;
    cursor: pointer;
    /* border: 2px solid #1F2D3D; */
  }
  .srsm_menu{
    bottom: 18%;
    left: 6%;
  }
  .srmm_menu{
    bottom: 18%;
    left: 29%;
  }
  .stmBack{
    bottom: 18%;
    right: 6%;
  }
  .srsm_pararm_fluence,.srsm_pararm_pulse,.srsm_pararm_frequency,.srmm_pararm_fluence,.srmm_pararm_pulse,.srmm_pararm_frequency{
    position: absolute;
    width: 268px;
    height: 244px;
    text-align: center;
    line-height: 190px;
    font-size: 6rem;
    cursor: pointer;
    /* border: 2px solid #000000; */
  }

  .srsm_pararm_fluence,.srmm_pararm_fluence{
    top: 24%;
    left: 4%;
  }
  .srsm_pararm_pulse,.srmm_pararm_pulse{
    top: 24%;
    left: 65%;
  }
  .srsm_pararm_frequency,.srmm_pararm_frequency{
    top: 24%;
    left: 35%;
  }
  .srmm_pararm_fluence,.srmm_pararm_pulse,.srmm_pararm_frequency{
    top: 30%;
  }

  .srsm_skinType{
    position: absolute;
    top: 17%;
    left: 4%;
    width: 856px;
    height: 84px;
  }
  .srmm_skinType{
    position: absolute;
    top: 25%;
    left: 4%;
    width: 856px;
    height: 84px;
  }
  .type1,.type2,.type3,.type4,.type5,.type6{
    float: right;
    width: 70px;
    height: 70px;
    margin-top: 10px;
    border: 2px solid #fff;
    cursor: pointer;
  }
    .type6{
      margin-right: 19px;
    }
    .type1,.type4,.type5{
      margin-right: 23px;
    }
    .type2,.type3{
      margin-right: 23px;
    }
    .fluence{
      position: absolute;
      top: 6%;
      left: 5%;
      font-size: 4rem;
      width: 156px;
      height: 192px;
      text-align: center;
      line-height: 192px;
    }
    .pulse{
      position: absolute;
      top: 7%;
      left: 36%;
      font-size: 4rem;
      width: 156px;
      height: 192px;
      text-align: center;
      line-height: 192px;
    }
    .frequency{
      position: absolute;
      top: 13%;
      left: 64%;
      font-size: 3rem;
      width: 156px;
      height: 90px;
      line-height: 90px;
      text-align: center;
    }
    .cooling{
      position: absolute;
      top: 37%;
      left: 64%;
      font-size: 3rem;
      width: 156px;
      height: 90px;
      line-height: 90px;
      text-align: center;
    }
    .hrm_fluence{
      position: absolute;
      top: 24%;
      left: 38%;
      font-size: 4rem;
    }
    .srsm_fluence{
      position: absolute;
      top: 18%;
      left: 4%;
      font-size: 4rem;
      width: 162px;
      height: 142px;
      text-align: center;
      line-height: 142px;
    }
    .srmm_fluence{
      position: absolute;
      top: 27%;
      left: 4%;
      font-size: 4rem;
      width: 162px;
      height: 142px;
      text-align: center;
      line-height: 142px;
    }
    .srsm_frequency{
      position: absolute;
      top: 18%;
      left: 35%;
      font-size: 4rem;
      width: 162px;
      height: 142px;
      text-align: center;
      line-height: 142px;
    }
    .srmm_frequency{
      position: absolute;
      top: 27%;
      left: 35%;
      font-size: 4rem;
      width: 162px;
      height: 142px;
      text-align: center;
      line-height: 142px;
    }
    .srsm_pulse{
      position: absolute;
      top: 18%;
      left: 66%;
      font-size: 4rem;
      width: 162px;
      height: 142px;
      text-align: center;
      line-height: 142px;
    }
    .srmm_pulse{
      position: absolute;
      top: 27%;
      left: 66%;
      font-size: 4rem;
      width: 162px;
      height: 142px;
      text-align: center;
      line-height: 142px;
    }
  }
  @media (max-width: 1400px){
    .menu_btn{
      position: absolute;
      bottom: 18%;
      left: 0;
      right: 0;
    }
    .hrm_btn,.hrs_btn,.stm_btn{
      display: inline-block;
      width: 140px;
      height: 54px;
      cursor: pointer;
      /* border: 2px solid #1F2D3D; */
    }
    .hrm_btn{
      margin-left: 6%;
    }
    .hrs_btn{
      margin-left: 4%;
    }
    .stm_btn{
      margin-left: 3%;
    }
    .hrmUp,.hrsUp,.srsmUp,.srmmUp,.hrmDown,.hrsDown,.srsmDown,.srmmDown,.hrmBack,.skinBack,.hrsBack,.srsmBack,.srmmBack,.hrmConfirm,.hrsConfirm,.srsmConfirm,.srmmConfirm{
      position: absolute;
      width: 100px;
      height: 100px;
      cursor: pointer;
      /* border: 2px solid #1F2D3D; */
    }
    .hrmUp{
      top: 20%;
      left: 5%;
    }
    .hrsUp{
      bottom: 6%;
      left: 5%;
    }
    .srsmUp{
      bottom: 6%;
      left: 4%;
    }
    .srmmUp{
      bottom: 5%;
      left: 4%;
    }
    .hrmDown{
      top: 55%;
      left: 5%;
    }
    .hrsDown{
      bottom: 6%;
      left: 20%;
    }
    .srsmDown{
      bottom: 6%;
      left: 19%;
    }
    .srmmDown{
      bottom: 5%;
      left: 19%;
    }
    .hrmBack{
      bottom: 25%;
      right: 5%;
    }
    .skinBack{
      bottom: -21%;
      right: 19%;
      width: 304px;
      height: 60px;
    }
    .hrsBack{
      bottom: 6%;
      right: 5%;
    }
    .srsmBack{
      bottom: 6%;
      right: 6%;
    }
    .srmmBack{
      bottom: 5%;
      right: 6%;
    }
    .hrmConfirm{
      bottom: 25%;
      right: 21%;
    }
    .hrsConfirm{
      bottom: 6%;
      right: 20%;
    }
    .srsmConfirm{
      bottom: 6%;
      right: 21%;
    }
    .srmmConfirm{
      bottom: 5%;
      right: 21%;
    }
    .hrm_pararm_fluence{
      position: absolute;
      top: -5%;
      left: 23%;
      width: 280px;
      height: 280px;
      text-align: center;
      line-height: 280px;
      font-size: 8rem;
      cursor: pointer;
    }
    .hrmSkin_menu{
      position: absolute;
      top: 9%;
      left: 20%;
      width: 466px;
      height: 356px;
      font-size: 0;
    }
    .hrmSkin_option{
      display: inline-block;
      margin: 7px 3px;
      width: 146px;
      height: 162px;
      cursor: pointer;
      /* border: 2px solid #1F2D3D; */
    }
  .hrs_pararm_fluence,.hrs_pararm_pulse{
    position: absolute;
    width: 210px;
    height: 260px;
    font-size: 6rem;
    text-align: center;
    line-height: 260px;
    cursor: pointer;
    /* border: 2px solid #000000; */
  }
  .hrs_pararm_frequency,.hrs_pararm_cooling{
    position: absolute;
    width: 210px;
    height: 122px;
    font-size: 4rem;
    text-align: center;
    line-height: 122px;
    cursor: pointer;
    /* border: 2px solid #000000; */
  }
  .hrs_pararm_fluence{
    top: -5%;
    left: 5%;
  }
  .hrs_pararm_pulse{
    top: -5%;
    left: 36%;
  }
  .hrs_pararm_frequency{
    top: 2%;
    right: 5%;
  }
  .hrs_pararm_cooling{
    top: 29%;
    right: 5%;
  }
  .srsm_menu,.srmm_menu,.stmBack{
    position: absolute;
    width: 134px;
    height: 56px;
    cursor: pointer;
    /* border: 2px solid #1F2D3D; */
  }
  .srsm_menu{
    bottom: 18%;
    left: 6%;
  }
  .srmm_menu{
    bottom: 18%;
    left: 29%;
  }
  .stmBack{
    bottom: 18%;
    right: 6%;
  }
  .srsm_pararm_fluence,.srsm_pararm_pulse,.srsm_pararm_frequency,.srmm_pararm_fluence,.srmm_pararm_pulse,.srmm_pararm_frequency{
    position: absolute;
    width: 210px;
    height: 190px;
    text-align: center;
    line-height: 190px;
    font-size: 6rem;
    cursor: pointer;
    /* border: 2px solid #000000; */
  }

  .srsm_pararm_fluence,.srmm_pararm_fluence{
    top: 15%;
    left: 4%;
  }
  .srsm_pararm_pulse,.srmm_pararm_pulse{
    top: 15%;
    left: 65%;
  }
  .srsm_pararm_frequency,.srmm_pararm_frequency{
    top: 15%;
    left: 35%;
  }
  .srmm_pararm_fluence,.srmm_pararm_pulse,.srmm_pararm_frequency{
    top: 24%;
  }

  .srsm_skinType{
    position: absolute;
    top: 17%;
    left: 4%;
    width: 666px;
    height: 70px;
  }
  .srmm_skinType{
    position: absolute;
    top: 25%;
    left: 4%;
    width: 666px;
    height: 70px;
  }
    .type6{
      margin-right: -12px;
    }
    .type1,.type4,.type5{
      margin-right: 23px;
    }
    .type2,.type3{
      margin-right: 22px;
    }
    .fluence{
      position: absolute;
      top: -2%;
      left: 5%;
      font-size: 4rem;
      width: 134px;
      height: 166px;
      text-align: center;
      line-height: 166px;
    }
    .pulse{
      position: absolute;
      top: -2%;
      left: 36%;
      font-size: 4rem;
      width: 134px;
      height: 166px;
      text-align: center;
      line-height: 166px;
    }
    .frequency{
      position: absolute;
      top: 4%;
      left: 65%;
      font-size: 3rem;
      width: 134px;
      height: 78px;
      line-height: 78px;
      text-align: center;
    }
    .cooling{
      position: absolute;
      top: 30%;
      left: 66%;
      font-size: 3rem;
      width: 134px;
      height: 78px;
      line-height: 78px;
      text-align: center;
    }
    .hrm_fluence{
      position: absolute;
      top: 2%;
      left: 24%;
      font-size: 4rem;
      width: 186px;
      height: 186px;
      text-align: center;
      line-height: 186px;
    }
    .srsm_fluence{
      position: absolute;
      top: 15%;
      left: 1%;
      font-size: 4rem;
      width: 162px;
      height: 142px;
      text-align: center;
      line-height: 142px;
    }
    .srmm_fluence{
      position: absolute;
      top: 20%;
      left: 1%;
      font-size: 4rem;
      width: 162px;
      height: 142px;
      text-align: center;
      line-height: 142px;
    }
    .srsm_frequency{
      position: absolute;
      top: 15%;
      left: 32%;
      font-size: 4rem;
      width: 162px;
      height: 142px;
      text-align: center;
      line-height: 142px;
    }
    .srmm_frequency{
      position: absolute;
      top: 20%;
      left: 32%;
      font-size: 4rem;
      width: 162px;
      height: 142px;
      text-align: center;
      line-height: 142px;
    }
    .srsm_pulse{
      position: absolute;
      top: 15%;
      left: 64%;
      font-size: 4rem;
      width: 162px;
      height: 142px;
      text-align: center;
      line-height: 142px;
    }
    .srmm_pulse{
      position: absolute;
      top: 20%;
      left: 64%;
      font-size: 4rem;
      width: 162px;
      height: 142px;
      text-align: center;
      line-height: 142px;
    }
  }
  @media (max-width: 1200px){
    .fluence{
      position: absolute;
      top: 6%;
      left: 5%;
      font-size: 4rem;
      width: 122px;
      height: 148px;
      text-align: center;
      line-height: 148px;
    }
    .pulse{
      position: absolute;
      top: 7%;
      left: 36%;
      font-size: 4rem;
      width: 122px;
      height: 148px;
      text-align: center;
      line-height: 148px;
    }
    .frequency{
      position: absolute;
      top: 13%;
      left: 64%;
      font-size: 3rem;
      width: 122px;
      height: 70px;
      line-height: 70px;
      text-align: center;
    }
    .cooling{
      position: absolute;
      top: 37%;
      left: 64%;
      font-size: 3rem;
      width: 122px;
      height: 70px;
      line-height: 70px;
      text-align: center;
    }
    .hrm_fluence{
      position: absolute;
      top: 24%;
      left: 38%;
      font-size: 4rem;
    }
    .srsm_fluence{
      position: absolute;
      top: 30%;
      left: 14%;
      font-size: 4rem;
    }
    .srsm_frequency{
      position: absolute;
      top: 30%;
      left: 45%;
      font-size: 4rem;
    }
    .srsm_pulse{
      position: absolute;
      top: 30%;
      left: 76%;
      font-size: 4rem;
    }
  }
  @media (min-width: 992px){
    .col-lg-4 {
      margin-right: 10px;
      flex: 0 0 42.333333%;
      max-width: 42.333333%;
    }
    .col-lg-5 {
      margin-right: 10px;
      flex: 0 0 33.333333%;
      max-width: 33.333333%;
    }
  }
  @media (max-width: 992px){
    .myself .name{
      float: right;
      padding: 0 4px 0 4px;
      text-align: right;
      }
    .myself .content{
      float: right;
      width: 240px;
      margin-left: 100px;
      padding: 6px;
      line-height: 20px;
      border: 1px solid #ccc;
      border-radius: 10px;
      text-align: right;
      word-break:break-all;
      background-color: rgba(0,255,0,.1);
    }
  }
  @media (min-width: 992px){
    .col-lg-6 {
      flex: 0 0 22.333333%;
      max-width: 22.333333%;
    }
  }
  @media (max-width: 570px) {
  	#email-wrap{
  		position: absolute;
  		top: 20%;
  		left: 50%;
  		margin-left: -180px;
  	}
  	#email-wrap-top{
  		position: absolute;
  		top: 20%;
  		left: 50%;
  		margin-left: -180px;
  	}
  	.email-left{
  		float: none;
  	}
  	.email-right{
  		float: none;
  		display: flex;
  		flex: 1;
  	}
    .equipment-left,.equipment-right{
      width: 160px;
      height: 210px;
  		margin: 0 10px 0 10px;
      border: 1px solid #999;
      border-radius: 4px;
      background-color: rgba(212,246,245,0.9);
  }
  .equipment-top,.equipment-bottom{
      width: 160px;
      height: 100px;
  		margin: 10px;
      border: 1px solid #999;
      border-radius: 4px;
      background-color: rgba(212,246,245,0.9);
  }
  }
  @media (max-width: 416px) {
  	#email-wrap{
  		position: absolute;
      top: 20%;
      left: 50%;
      margin-left: -114px;
  	}
  	#email-wrap-top{
  		position: absolute;
      top: 20%;
      left: 50%;
      margin-left: -114px;
  	}
  	.email-left{
  		float: none;
  	}
  	.equipment-left > p{
  		margin-top: 0;
  		margin-bottom: 6px;
  		font-size:3rem!important;
  	}
  	.equipment-right > p{
  		margin-top: 0;
  		margin-bottom: 6px;
  		font-size:3rem!important;
  	}
  	.email-right{
  		float: none;
  		display: flex;
  		flex: 1;
  	}
    .equipment-left,.equipment-right{
      width: 107px;
      height: 145px;
      margin: 0 4px 0 4px;
      border: 1px solid #999;
      border-radius: 4px;
      background-color: rgba(212,246,245,0.9);
  	}
  .equipment-top,.equipment-bottom{
      width: 107px;
      height: 100px;
      margin: 4px;
      border: 1px solid #999;
      border-radius: 4px;
      background-color: rgba(212,246,245,0.9);
  }
  }
  .face-color-1{
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
  	background-color: rgb(247,227,220)!important;
  }
  .face-color-2{
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
  	background-color: rgb(255,190,158)!important;
  }
  .face-color-3{
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
  	background-color: rgb(222,176,153)!important;
  }
  .face-color-4{
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
  	background-color: rgb(189,152,133)!important;
  }
  .face-color-5{
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
  	background-color: rgb(118,82,56)!important;
  }
  .face-color-6{
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
  	background-color: rgb(31,25,25)!important;
  }
  .border{
    border: 1px solid #409EFF;
  }


</style>



// WEBPACK FOOTER //
// src/components/realTime.vue